export default __webpack_public_path__ + "static/media/p-4.9e0b4043.png";